import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ApplicationProductsService } from '@services/api-calls/application-products.service';
import { ApplicationStateService } from '@services/application-state.service';
import { EMPTY } from 'rxjs';

export const completedAppInterceptor: HttpInterceptorFn = (req, next) => {
    const applicationStateService = inject(ApplicationStateService);
    const productsService = inject(ApplicationProductsService);

    if (applicationStateService.isAdvisorCompleted() || applicationStateService.isExpired()) {
        return EMPTY;
    }

    if (applicationStateService.isCompleted() || productsService.isDeclined()) {
        const method = req.method.toUpperCase();
        if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
            return EMPTY;
        }
    }

    return next(req);
};
